// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { Container } from "@ifeng/lowcode_basic/src/components/layout/Container/index.tsx";

import { PageNav_1 } from "@ifeng/lowcode_basic/src/components/nav/PageNav_1/index.tsx";

import { LayoutComponent } from "@ifeng/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { Row } from "@ifeng/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_7 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_7/index.tsx";

import { NewsList_6 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_6/index.tsx";

import { ImageLink } from "@ifeng/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { NewsList_3 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_3/index.tsx";

import { NewsList_5 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_5/index.tsx";

import { NewsList_12 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { Image_Tabs } from "@ifeng/lowcode_business/src/components/images/Image_Tabs/index.tsx";

import { NewsList_2 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_2/index.tsx";

import { Support } from "@ifeng/lowcode_basic/src/components/popular/Support/index.tsx";

import { Comment } from "@ifeng/lowcode_basic/src/components/popular/Comment/index.tsx";

import { Footer } from "@ifeng/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div>
        <Container width={1000} isCenter={true} $isHide={false}>
          <PageNav_1
            navChip={{
              $data: true,
              id: "260314",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260274" },
              uuid: "6f209e9b",
            }}
          />
        </Container>
        <Container
          isCenter={true}
          $isHide={false}
          style={{
            backgroundImage:
              "url(https://x0.ifengimg.com/ucms/2022_38/720BC5ACB412BC92E347A4E0FF76B3EEE2839EF2_size483_w1920_h815.jpg)",
            paddingTop: "330px",
            backgroundPositionX: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Container width={1000} isCenter={true} $isHide={false}>
            <Container isCenter={true} $isHide={false}>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl1">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  $isHide={false}
                >
                  <Col
                    width={{ type: "flex", size: "1" }}
                    style={{ marginRight: "30px" }}
                  >
                    <Title
                      height={54}
                      image=""
                      text=""
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText=""
                      isTextHasIcon={true}
                      style={{ marginBottom: "20px" }}
                      textIcon="https://y2.ifengimg.com/a/2014_15/7b090fcd6711a14.jpg"
                      isHasAddonAfterIcon={true}
                      addonAfterIcon="https://x0.ifengimg.com/ucms/2022_38/A75EB0A08F982A1F02BFE6384972CC8E26668D55_size10_w200_h55.png"
                      addonAfterIconHeightFull={true}
                    />
                    <NewsList_1
                      newsChip={{
                        $data: true,
                        id: "286013",
                        type: "recommend",
                        title: "新闻内容",
                        default: { type: "recommend", id: "285838" },
                        uuid: "b1eb7440",
                        force: 1661225459857,
                      }}
                      hoverColor="#ba2636"
                      titleStyle={{
                        color: "#2b2b2b",
                        fontSize: "24px",
                        lineHeight: "32px",
                        marginBottom: "9px",
                      }}
                      subTitleGroupSize={2}
                      subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                    />
                  </Col>
                  <Col width={{ size: 323, type: "px" }}>
                    <Title
                      height={48}
                      image="https://x0.ifengimg.com/ucms/2020_47/17814A890D32099957F8282CB0CE38ACC11311F7_w320_h48.jpg"
                      text=""
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{}}
                    />
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: 286038,
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "e4408b9d",
                      }}
                      height={260}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={true}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={40}
                      titleStyle={{
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "#fff",
                        fontSize: "14px",
                        paddingLeft: "8px",
                        whiteSpace: "nowrap",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleRight"
                      paginationNormalStyle={{
                        backgroundColor: "#b8defb",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "16px",
                        height: "16px",
                        marginLeft: "4px",
                        marginRight: "7px",
                      }}
                      paginationActiveStyle={{ backgroundColor: "#2879bc" }}
                      paginationTotalStyle={{}}
                      skin={2}
                      style={{ fontWeight: 100 }}
                    />
                    <Title
                      height={48}
                      image="https://x0.ifengimg.com/ucms/2020_48/AFCF82A1DC67B28A232584985081AC12845CF590_w320_h48.jpg"
                      text=""
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                        paddingLeft: "0px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{ marginTop: "30px", marginBottom: "0px" }}
                    />
                    <VideoList_1
                      videoChip={{
                        $data: true,
                        id: "286015",
                        type: "recommend",
                        title: "视频列表",
                        format: {
                          filter: ["title", "posterUrl", "videoPlayUrl"],
                        },
                        default: { type: "recommend", id: "285924" },
                        uuid: "83d3ca50",
                      }}
                      width={323}
                      height={240}
                      autoPlay={false}
                      controls={true}
                      hoverColor="#ba2636"
                      skin={0}
                      continuePlay={false}
                      listHeight={48}
                      listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                      listIconWidth={14}
                      listIconHeight={11}
                    />
                  </Col>
                </Row>
              </LayoutComponent>
              <Container isCenter={true}>
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="李家超凤凰演讲"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{
                    marginTop: "30px",
                    marginBottom: "10px",
                    textAlign: "left",
                  }}
                />
                <NewsList_7
                  newsChip={{
                    $data: true,
                    id: "286112",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285973" },
                    uuid: "89412505",
                  }}
                  style={{ fontSize: "22px" }}
                  mainArticleTitleStyle={{
                    paddingLeft: "0px",
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "25px",
                    marginBottom: "30px",
                    lineHeight: "40px",
                  }}
                />
              </Container>
              <LayoutComponent isCenter={true} nodeId="node_ocl7zsvz7p4">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="开幕演讲"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <NewsList_6
                  newsChip={{
                    $data: true,
                    id: "286027",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285916" },
                    uuid: "26cbccf7",
                  }}
                />
              </LayoutComponent>
              <Container isCenter={true}>
                <Container isCenter={true}>
                  <ImageLink
                    image="https://x0.ifengimg.com/ucms/2022_38/4DD4CD1F4F1071A7B99E01003AE1941FFF744381_size27_w1000_h90.jpg"
                    url=""
                    isBlock={true}
                    width={300}
                    height={90}
                    objectFit="none"
                    style={{ marginTop: "15px" }}
                  />
                </Container>
              </Container>
              <LayoutComponent isCenter={true} nodeId="node_ocl7zsvz7p1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="大变局下的全球经济挑战"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <NewsList_3
                  newsChip={{
                    $data: true,
                    id: "286114",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285872" },
                    uuid: "210e0ee0",
                  }}
                  isMore={true}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl8bbo9lo1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="“和”而不同--全球视野下的中国新叙事"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <NewsList_7
                  newsChip={{
                    $data: true,
                    id: "286115",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285973" },
                    uuid: "5d06a076",
                  }}
                  mainArticleTitleStyle={{
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "25px",
                    lineHeight: "40px",
                    marginBottom: "30px",
                  }}
                />
              </LayoutComponent>
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2022_38/F03121601B6BC8A3CB3895BD2E47FBFEF1857793_size38_w1000_h90.jpg"
                url=""
                isBlock={true}
                width={300}
                height={90}
                objectFit="none"
                style={{ marginTop: "15px" }}
              />
              <LayoutComponent isCenter={true} nodeId="node_ocl7zsvz7p3">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="9月21日圆桌论坛"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <NewsList_5
                  newsChip={{
                    $data: true,
                    id: "286050",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "source",
                        "position",
                      ],
                    },
                    default: { type: "recommend", id: "285908" },
                    uuid: "30e329dd",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl8cg30652">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="中国经济新势能"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "286125",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "36f116d9",
                  }}
                  colNum={3}
                  thumbnailWidth={320}
                  thumbnailHeight={180}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={2}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "15px",
                    color: "#2b2b2b",
                    fontSize: "18px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    marginBottom: "10px",
                  }}
                  showSummary={true}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl2">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="地产周期：前景与趋势"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "286132",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "576005d5",
                  }}
                  colNum={3}
                  thumbnailWidth={320}
                  thumbnailHeight={180}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={2}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "15px",
                    color: "#2b2b2b",
                    fontSize: "18px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    marginBottom: "10px",
                  }}
                  showSummary={true}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                />
              </LayoutComponent>
              <Container isCenter={true}>
                <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl3">
                  <Title
                    height={50}
                    image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                    text="9月22日论坛"
                    textStyle={{
                      paddingLeft: "24px",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "24px",
                    }}
                    textAlign="flex-start"
                    isHasAddonAfter={false}
                    addonAfterText="更多"
                    isTextHasIcon={false}
                    style={{ marginTop: "30px", marginBottom: "10px" }}
                  />
                  <NewsList_5
                    newsChip={{
                      $data: true,
                      id: "286129",
                      type: "recommend",
                      title: "新闻内容",
                      format: {
                        filter: [
                          "thumbnails",
                          "title",
                          "type",
                          "url",
                          "base62Id",
                          "summary",
                          "children",
                          "source",
                          "position",
                        ],
                      },
                      default: { type: "recommend", id: "285908" },
                      uuid: "78ff464f",
                    }}
                  />
                </LayoutComponent>
                <Container isCenter={true}>
                  <LayoutComponent isCenter={true} nodeId="node_ocl8csq08k4">
                    <Title
                      height={50}
                      image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                      text="多层次资本市场建设与企业高质量发展"
                      textStyle={{
                        paddingLeft: "24px",
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{ marginTop: "30px", marginBottom: "10px" }}
                    />
                    <NewsList_3
                      newsChip={{
                        $data: true,
                        id: "286138",
                        type: "recommend",
                        title: "新闻内容",
                        default: { type: "recommend", id: "285872" },
                        uuid: "ca7a0132",
                      }}
                      isMore={false}
                    />
                    <NewsList_12
                      newsChip={{
                        $data: true,
                        id: "286139",
                        type: "recommend",
                        title: "新闻内容",
                        default: { type: "recommend", id: "285873" },
                        uuid: "1e4bd985",
                      }}
                      colNum={3}
                      thumbnailWidth={320}
                      thumbnailHeight={180}
                      showThumbnailHoverScale={true}
                      isHasTitle={true}
                      titleRows={2}
                      titleHoverColor="#ba2636"
                      titleStyle={{
                        paddingTop: "15px",
                        color: "#2b2b2b",
                        fontSize: "18px",
                        lineHeight: "24px",
                        fontWeight: 700,
                        marginBottom: "10px",
                      }}
                      showSummary={true}
                      summaryRows={3}
                      summaryStyle={{
                        color: "#666666",
                        fontSize: "14px",
                        lineHeight: "24px",
                      }}
                      moreText="[详细]"
                      moreStyle={{ color: "#ba2636" }}
                      style={{ marginTop: "15px" }}
                    />
                  </LayoutComponent>
                </Container>
                <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl6">
                  <Title
                    height={50}
                    image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                    text="高清图集"
                    textStyle={{
                      paddingLeft: "24px",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "24px",
                    }}
                    textAlign="flex-start"
                    isHasAddonAfter={false}
                    addonAfterText="更多"
                    isTextHasIcon={false}
                    style={{ marginTop: "30px", marginBottom: "10px" }}
                  />
                  <Swiper_1
                    swiperChip={{
                      $data: true,
                      id: "286019",
                      type: "recommend",
                      title: "轮播图内容",
                      default: { type: "recommend", id: "285915" },
                      uuid: "5ab7a0a2",
                    }}
                    height={620}
                    isHasNav={false}
                    leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                    rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                    navWidth={22}
                    navHeight={40}
                    navY={290}
                    navX={15}
                    isAutoPlay={true}
                    autoSpeed={3000}
                    skin={0}
                    isHasPagination={false}
                    isHasTitle={true}
                    titleHeight={60}
                    titleStyle={{
                      background: "linear-gradient(180deg,transparent,#000)",
                      color: "#fff",
                      fontSize: "17px",
                      paddingLeft: "15px",
                      paddingRight: "15px",
                    }}
                    paginationPosition="titleBottom"
                    paginationNormalStyle={{
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      borderTopLeftRadius: "50px",
                      borderTopRightRadius: "50px",
                      borderBottomLeftRadius: "50px",
                      borderBottomRightRadius: "50px",
                      width: "4px",
                      height: "4px",
                      marginLeft: "4px",
                      marginRight: "4px",
                    }}
                    paginationActiveStyle={{
                      borderTopLeftRadius: "2px",
                      borderTopRightRadius: "2px",
                      borderBottomLeftRadius: "2px",
                      borderBottomRightRadius: "2px",
                      width: "12px",
                    }}
                    paginationTotalStyle={{ marginBottom: "10px" }}
                  />
                </LayoutComponent>
              </Container>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl5">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="湾区风云录"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={true}
                  addonAfterText=""
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  isHasAddonAfterIcon={true}
                  addonAfterIcon="https://x0.ifengimg.com/ucms/2022_38/A75EB0A08F982A1F02BFE6384972CC8E26668D55_size10_w200_h55.png"
                  addonAfterIconHeightFull={true}
                />
                <VideoList_1
                  videoChip={{
                    $data: true,
                    id: "286018",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "285924" },
                    uuid: "a577344b",
                  }}
                  width={580}
                  height={457}
                  autoPlay={false}
                  controls={true}
                  hoverColor="#ba2636"
                  skin={1}
                  continuePlay={false}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7zsvz7p5">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="回顾 | 林郑月娥凤凰网财经峰会演讲"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{
                    marginTop: "30px",
                    marginBottom: "10px",
                    textAlign: "left",
                  }}
                />
                <NewsList_7
                  newsChip={{
                    $data: true,
                    id: "286029",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285973" },
                    uuid: "f021659b",
                  }}
                  style={{}}
                  mainArticleTitleStyle={{
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "25px",
                    lineHeight: "40px",
                    marginBottom: "30px",
                  }}
                />
              </LayoutComponent>
              <ImageLink
                image="https://x0.ifengimg.com/ucms/2022_38/2E6D16B9AD0B8C45C69E0F06C6B11EC6EDB61FAD_size30_w1000_h90.jpg"
                url=""
                isBlock={true}
                width={300}
                height={90}
                objectFit="none"
                style={{ height: "110px", marginTop: "15px" }}
              />
              <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl7">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="论坛议程"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <Image_Tabs
                  imagesChip={{
                    $data: true,
                    id: "260316",
                    type: "struct",
                    title: "图片信息",
                    default: { type: "struct", id: "260307" },
                    uuid: "b38f93cd",
                  }}
                  contentHeight={800}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o5zpzl8">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="相关报道"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  $isHide={false}
                >
                  <Col width={{ type: "flex", size: "1" }}>
                    <Title
                      height={30}
                      image=""
                      text="嘉宾观点"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "286117",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "b69c2580",
                      }}
                      useMaxHeight={true}
                      maxHeight={400}
                    />
                    <Title
                      height={30}
                      image=""
                      text="相关报道"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "286020",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "31db047c",
                      }}
                      useMaxHeight={true}
                      maxHeight={400}
                    />
                  </Col>
                  <Col
                    width={{ size: 335, type: "px" }}
                    style={{ marginLeft: "20px" }}
                  >
                    <Support
                      supportChip={{
                        $data: true,
                        id: "260317",
                        type: "struct",
                        title: "赞助列表",
                        default: { type: "struct", id: "260259" },
                        uuid: "8b7b8db7",
                        force: 1661225459896,
                      }}
                      rightsName="财经"
                      rightsUrl="https://finance.ifeng.com"
                    />
                  </Col>
                </Row>
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7zsvz7p6">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2021_43/F97F8E24D50E6D4FBDD0ECB6C743B9A9A10D1ED7_size42_w1000_h70.jpg"
                  text="网友评论"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                />
                <Comment
                  url="https://finance.ifeng.com/loc/wqgjcjlt/"
                  title="鳳凰灣區財經論壇2022"
                />
              </LayoutComponent>
            </Container>
          </Container>
          <Footer year="2022" style={{ marginTop: "60px" }} />
        </Container>
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
